import React, { Component } from 'react';
import { Popover, Icon } from 'antd-mobile';
//城市选择
const Item = Popover.Item;
function NumberList(props) {
  const posts = props.posts;
  const statea = props.statea;
  return (
    <Popover mask
      overlayClassName="fortest"
      overlayStyle={{ color: 'currentColor' }}
      visible={statea.visible}
      onVisibleChange={props.handleVisibleChange}
      onSelect={props.onSelect}
      overlay=
      {posts.map((number) =>
        <Item key={number.key} value={number.value} >{number.text}</Item>
      )}
      align={{
        overflow: { adjustY: 0, adjustX: 0 },
        offset: [-10, 0],
      }}
    >
      <div style={{
        height: '100%',
        padding: '0 15px',
        marginRight: '-15px',
        display: 'flex',
        alignItems: 'center',
      }}
      >{statea.selected}
        <Icon type="down" size="xxs" />
      </div>
    </Popover>
  );
}
export default class Citychange extends Component {
  constructor(props) {
    super(props);
    this.posts = [
      { key: 1, value: '330200', text: '宁波' }, { key: 2, value: '330100', text: '杭州' }, { key: 3, value: '330300', text: '温州' }
    ];
    if (!window.globalvariable.getStore('cityid')) {
      window.globalvariable.setStore('cityid', global.constants.cityid);
    }
    var selectpost= this.posts.find(value=>value.value === window.globalvariable.getStore('cityid') );
    this.state = {
      visible: false,
      selected: selectpost.text,
      value:  selectpost.value,
      id: '1'
    };
  }
  onSelect = (opt) => {
    window.globalvariable.setStore('cityid', opt.props.value);
    this.setState({
      visible: false,
      selected: opt.props.children,
      value: opt.props.value,
      id: opt.key
    });
    this.props.toParent(opt.props);
    this.props.GetPageMidcailCenter();

  };
  handleVisibleChange = (visible) => {
    this.setState({
      visible,
    });

  };
  render() {
    return (<NumberList posts={this.posts} statea={this.state} onSelect={this.onSelect} onVisibleChange={this.onVisibleChange} />
    )
  }


}
